import {
    CREATEPRESCRIPTION, 
    CREATEPRESCRIPTIONMEDICINE,
    CREATEPRESCRIPTIONROLL, 
    DELETEPRESCRIPTION, 
    DELETEPRESCRIPTIONMEDICINE,
    DELETEPRESCRIPTIONROLL, 
    GETPRESCRIPTION, 
    GETPRESCRIPTIONMEDICINE,
    GETPRESCRIPTIONROLL,
    UPDATEPRESCRIPTION, 
    UPDATEPRESCRIPTIONMEDICINE, 
    UPDATEPRESCRIPTIONROLL
     } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEPRESCRIPTION:
            return {
                ...state,
                prescriptionSaveStatus: action.payload.success,
            }
        case GETPRESCRIPTION:
                return {
                        ...state,
                        prescriptionList: action.payload.data,
                        }
        case UPDATEPRESCRIPTION:
                return {
                        ...state,
                        prescriptionUpdateStatus: action.payload.success,
                        }   

        case DELETEPRESCRIPTION:
                 return {
                     ...state,
                     prescriptionDeleteStatus: action.payload.success,
                        } 

         case CREATEPRESCRIPTIONMEDICINE:
            return {
                ...state,
                prescriptionmedicineSaveStatus: action.payload.success,
            }
        case GETPRESCRIPTIONMEDICINE:
                return {
                        ...state,
                        prescriptionmedicineList: action.payload.data,
                        }
        case UPDATEPRESCRIPTIONMEDICINE:
                return {
                        ...state,
                        prescriptionmedicineUpdateStatus: action.payload.success,
                        }   

        case DELETEPRESCRIPTIONMEDICINE:
                 return {
                     ...state,
                     prescriptionmedicineDeleteStatus: action.payload.success,
                        } 
        case CREATEPRESCRIPTIONROLL:
            return {
                ...state,
                prescriptionroleSaveStatus: action.payload.success,
            }
        case GETPRESCRIPTIONROLL:
                return {
                        ...state,
                        prescriptionroleList: action.payload.data,
                        }
        case UPDATEPRESCRIPTIONROLL:
                return {
                        ...state,
                        prescriptionroleUpdateStatus: action.payload.success,
                        }   

        case DELETEPRESCRIPTIONROLL:
                 return {
                     ...state,
                     prescriptionroleDeleteStatus: action.payload.success,
                        } 

                        default:
                            return state
                             }
                         }